import api from "./api"

export const loginAPI = async ({ user_id, password }) => {
  const { data } = await api.post("/api/auth/login", { user_id, password })
  return data
}

export const logoutAPI = async () => {
  try {
    const res = await api.post("/api/auth/logout")
    return res.status === 200
  } catch {
    return false
  }
}

export const accessUserAPI = async () => {
  try {
    const { data } = await api.get("/api/auth/me")
    return data
  } catch (err) {
    if (err.response?.status === 401) {
      return false
    }
  }
}

export const changePasswordAPI = async ({ current_password, new_password }) => {
  const { data } = await api.patch("/api/auth/password", { current_password, new_password })
  return data
}

export const verifyPasswordAPI = async ({ current_password }) => {
  const { data } = await api.post("/api/auth/password/verify", { current_password })
  return data
}

export const getProfileAPI = async () => {
  const { data } = await api.get("/api/auth/profile")
  return data
}

export const updateProfileAPI = async (profile) => {
  const { data } = await api.patch("/api/auth/profile", profile)
  return data
}

export const logPageAccessAPI = async ({ page_name, path }) => {
  const { data } = await api.post("/api/auth/page-access", { page_name, path })
  return data
}
